import { render, staticRenderFns } from "./AppHorizontalMenus.vue?vue&type=template&id=42543962&"
import script from "./AppHorizontalMenus.vue?vue&type=script&lang=js&"
export * from "./AppHorizontalMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports